// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__m9F7x","box":"style_box__wswu6","active":"style_active__VgGo6","title":"style_title__gf+pA","item":"style_item__z1Mn4"};